import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import styles from "./GuestScreen6.module.css";
import { SubmitButton, TextComponent } from "../../../../components";

const GuestScreen6 = ({ setCurrentStep }) => {
  const WeddingWeb = useSelector((state) => state.EventReducer.WeddingWeb);
  const navigate = useNavigate();
  const dummyData = [
    {
      id: 1,
      answer:
        "In the midst of a bustling room, our eyes locked, and time stood still. In her gaze, I found my home, and with every word, I felt the universe conspiring to bring us closer.",
    },
    {
      id: 2,
      answer:
        "In the midst of a bustling room, our eyes locked, and time stood still. In her gaze, I found my home, and with every word, I felt the universe conspiring to bring us closer.",
    },
  ];
  return (
    <div className={styles.mainCont}>
      <TextComponent text={"Accommodation"} textClass={styles.heading} />
      {/* <List
            dataSource={dummyData}
            className={styles.list}
            renderItem={(item,index)=>{
                return (
                    <div className={styles.listItem} key={index}>
                        <TextComponent text={item?.answer} textClass={styles.answer}/>
                    </div>
                )
            }}
            /> */}
      <div className={styles.listItem}>
        <TextComponent
          text={WeddingWeb?.accommodation}
          textClass={styles.answer}
        />
      </div>
      <div className={styles.submitBtn}>
        <SubmitButton
          btnClass={styles.nextBtn2}
          title={"Back to home"}
          onClick={() => navigate("/guestEvents")}
        />
      </div>
    </div>
  );
};

export default GuestScreen6;
